export default {
    PROXY_URL: 'https://api.gfu.cloud/api',
    BASE_URL: 'https://meinangebot.lab.gfu.cloud',
    PDF_API_URL: 'https://meinangebot.lab.gfu.cloud/api',
    GFU_API_URL: 'https://db.intern.gfu.net/api',
    PDF_API_URL_REMOTE: 'http://meinangebot.lab.gfu.cloud:3000/api',
    FALLBACK_ORIGINAL: 'https://meinangebot.gfu.net',
    API_KEY: "meinangebot",
}
